// src/components/Protected.jsx
import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import api from '../lib/api';

export default function Protected({ children }) {
  // loading: true until /me resolves; authed: true when /me returns 200
  const [auth, setAuth] = useState({ loading: true, authed: false });
  const location = useLocation();

  useEffect(() => {
    let alive = true;

    // Don't throw on 401 so we can branch cleanly.
    api
      .get('/me', { validateStatus: (s) => s < 500 })
      .then((res) => {
        if (!alive) return;
        setAuth({ loading: false, authed: res.status === 200 });
      })
      .catch(() => {
        if (!alive) return;
        setAuth({ loading: false, authed: false });
      });

    return () => {
      alive = false;
    };
  }, []);

  if (auth.loading) {
    return <div style={{ height: 1 }} />;   // tiny placeholder avoids some Edge/extension DOM hiccups
  }

  // Single, deterministic redirect when unauthenticated
  if (!auth.authed) {
    return (
      <Navigate
        to="/"
        replace
        state={{ showSignIn: true, from: location.pathname }}
      />
    );
  }

  // Authenticated: render the protected content
  return children;
}


